import React, {useState ,useEffect, useCallback} from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core';
import { useTheme, Button, Dialog, DialogActions, DialogTitle, Modal, Box  } from '@mui/material';
import { AiOutlineClose } from 'react-icons/ai';
import {BsPerson} from 'react-icons/bs';
import {FiShoppingCart} from 'react-icons/fi';
import {GiHamburgerMenu} from 'react-icons/gi';
import { CgSearch } from 'react-icons/cg';
import { MdOutlineClose, MdOutlinePersonOutline, MdKeyboardArrowRight } from 'react-icons/md';
import { RiShoppingCartLine } from 'react-icons/ri';
import { TiPencil } from 'react-icons/ti';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { GoBook } from 'react-icons/go';
import { TbHeadphones, TbSpeakerphone } from 'react-icons/tb';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserInfo, setLogin } from "../redux/userSlice";
import axios from 'axios';
import useWindowDimensions from '../utils/useWindowDimensions';
import mainPath from '../utils/path';
import { setOrderAll, setPageAll } from '../redux/pageSlice';

const useStyles = makeStyles((theme)=>({
    HeaderBlock:{
        background:'#fff',
        boxShadow:'0px 0px 2px #AAA',
        zIndex: 99, 
        position:'fixed',
        top:'0',
        left:'0px', 
        width:'100%',
        fontFamily:[
            'Noto Sans KR'
        ],

    },
    row:{  
        maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'10px 0 3px 0', 
        
        [theme.breakpoints.down(1025)]: {
            padding:'0', 
        }
    },  
    banner: props => ({  
        background: props.palette.third.dark,
        color:'#fff',
        height:'42px',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        position:'relative',

        [theme.breakpoints.down(1025)]: {
            background:'#fff',
            color:'#000',
            width: '100%',
            overflow: 'auto',
            whiteSpace: 'nowrap',
            '&::-webkit-scrollbar': {
                width: 0,
                height: 0,
            },
        },
        [theme.breakpoints.down(365)]: {
            paddingLeft: 80
        }
    }),
    colorChange:{
        [theme.breakpoints.down(1025)]: {
            color:'#007235',
        }
    },
    bannerSpan:{
        fontSize:'14px',
        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            fontSize:'0.75em',
        }
    },
    close:{
        position:'absolute',
        top:'35%', 
        right:'320px',
        cursor:'pointer',

        [theme.breakpoints.down(1025)]: {
            left:'5px'
        } 
    },
    logoFlexDiv:{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        maxWidth:'1280px',
        margin:'20px auto',
        padding:'0 10px',

        [theme.breakpoints.down(1025)]: {
            background:'#007235',
            height:'55px',
            margin:'0',
        } 
    },
    logoDiv:{
        
    },
    pclogoimg:{ 
        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    },
    leftDiv:{
        position:'relative',
        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    },
    leftNumber:{
        position:'absolute',
        top:'40%',
        left:'5%',
        color:'#007235',
        fontSize:'23px',
        fontWeight:'600',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    rightDiv:{
        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    },
    rightAbsoluteDiv:{
        display:'flex',
        justifyContent:'space-evenly',
    },
    rightDetailDiv:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        padding:'0 10px',
        cursor:'pointer',
        borderLeft:'1px solid #ddd',
        '&:first-child':{
            border:'none'
        },
    },
    rightIcon:{
        color:'#007235',
        fontSize:'30px',
    },
    rightSpan:{
        color:'#007235',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    mobilelogoimg:{
        display:'none',
        position: 'absolute',
        left:'50%',
        transform:'translate(-50%, -50%)',

        [theme.breakpoints.down(1025)]: {
            display:'block',
        }
    },
    topmenu:{
        padding:'0 10'
    },
    topmenuUl:{ 
        display:'flex', 
        justifyContent:'flex-end',
        
        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    },
    topmenuLi:{ 
        fontSize:'13px',
        padding:'0 15px',
        color:'#666666', 
        borderRight:'1px solid #666666',
        cursor: 'pointer',
        fontFamily:[
            'Noto Sans KR'
        ],
        '&:last-child':{ 
            paddingRight:'0',
            borderRight:'0',
        }

    },   
    responsiveSearchDiv:{
        display:'none',
        fontSize:'25px',
        position:'absolute',
        right:'1.5%',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            display:'flex',
            justifyContent: 'space-between'
        },
        [theme.breakpoints.down(501)]: {
            display:'none',
        }
    },
    searchBtn:{
        display:'none',
        fontSize:'25px',
        position:'absolute',
        right:'1.5%',
        [theme.breakpoints.down(501)]: {
            display:'block',
        },
    },
    responsiveSearch:{
        color:'#fff',
    },
    navDiv:{ 
        display:'flex', 
        alignItems:'center',
        //paddingBottom:'10px',
        justifyContent:'space-between',
        padding:'0 10px',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
        }
    },
    navUlFirst:{        
        display:'flex', 
        justifyContent:'space-between', 
        width:'56%',
        [theme.breakpoints.down(1025)]: {
            padding:'10px',
            width:'100%',           
            overflow: 'auto',
            whiteSpace: 'nowrap',
            '&::-webkit-scrollbar': {
                width: 0,
                height: 0,
            },
        },
        [theme.breakpoints.down(365)]: {

        }
    },
    navLi:{ 
        cursor: 'pointer',
        '&:hover':{
            color:'#007235'
        },
        [theme.breakpoints.down(1025)]: {
            fontSize:'0.8em',
            marginRight: 5
        }
    },
    navUlSecond:{
        display:'flex',
        justifyContent:'space-evenly',
        alignItems:'center',
        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    },
    search:{
        position:'relative',
    },
    inputSearch:{
        border: 'none',
        background:'#F5F5F5',
        borderRadius:'100px',
        padding:'0 0 0 20px',
        width:'371px',
        height:'36px',
        '&:focus-within':{
            outline:'none'
        }
    },
    btnSearch:{
        width:'14px',
        height:'14px',
        position:'absolute',
        top:'25%',
        right:'5%',
        
    },
    io:{
        fontSize:'30px',
        margin:'0 15px',
        transition:'all 0.5s',
        '&:hover':{
            color:'#007235'
        }
    },
    fi:{
        fontSize:'25px',
        transition:'all 0.5s',
        '&:hover':{
            color:'#007235'
        }
    },
    mobileBack: {
        position: 'relative',
    },
    toggleDiv:{
        position:'fixed',
        top:0,
        bottom:0,
        left:0,
        right:0,
        backgroundColor: 'rgba( 0.5, 0.5, 0.5, 0.5 )',
        overflowY:'auto', 
        overflowX:'hidden',
    },
    mobileNavDiv: props => ({
        display:'none',
        transition:'0.5s',
        position:'absolute',
        width:'70%',
        height:'100%',
        left: props.toggleMenu ? 0 : '-70%',
        background:'#fff',
        [theme.breakpoints.down(1025)]: {
            display:'block',
        }
    }),
    mobileLogin:{
        cursor: 'pointer',
        [theme.breakpoints.down(1025)]: {
            padding:'10px',
            fontSize:'14px',            
        }       
    },
    mobileLoginSpan1:{
        borderRight:'1px solid #fff',
        paddingRight:'10px',
        textDecoration: 'underline',
        fontWeight:'300',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    mobileLoginSpan2:{
        paddingLeft:'10px',
        textDecoration: 'underline',
        fontWeight:'300',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    mobileGreenUl:{
        [theme.breakpoints.down(1025)]: {
            background:'#007235',
            color:'#fff'
        }
        
    },
    mobileGreenLi: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid white',
    },
    threeFlexLi:{
        [theme.breakpoints.down(1025)]: {
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            borderRight:'1px solid #ddd',
        }        
    },
    mobileNavUlFirst: {
        background:'#fff',
        height: '85vh',
        overflow: 'scroll'
    },
    mobileNavUlFirstmenu:{
        padding:'15px 0 15px 15px',
        color:'#007235',
        letterSpacing:'-0.75px',
        fontWeight:'600',
        borderBottom:'2px solid #ddd',
    },
    mobileNavUlFirstmenu2:{
        padding:'20px 0 15px 15px',
        color:'#007235',
        letterSpacing:'-0.75px',
        fontWeight:'600',
        borderBottom:'2px solid #ddd',
    },
    threeFlex:{
        [theme.breakpoints.down(1025)]: {
            width:'33%',
            height:'11vh',
            borderRight:'1px solid #ddd',
            '&:last-child':{ 
                borderRight:'0',
            }
        }    
    },
    threeFlexIconLi:{
        textAlign:'center',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        
    },
    threeFlexIcon:{
        fontSize:'37px', 
        alignItems:'center',
        justifyContent:'center', 
        
        [theme.breakpoints.down(1025)]: {
            marginTop:'15px',

        }
    },
    threeFlexTextLi:{
        textAlign:'center',
        fontSize:'13px',
    },
    mobileNavLi:{
        cursor: 'pointer',
        [theme.breakpoints.down(1025)]: {
            display:'flex',
            justifyContent:'space-between',
            alignItems:'center',
            borderBottom:'2px solid #ddd',
            height:'50px',
            fontWeight:'500',
        }        
    },
    textFlex:{
        display:'flex',
        justifyContent:'flex-start',
        alignItems:'center',
    },
    colorBox:{
        background:'#F7FBF2',
        height:'48px',
        width:'20px'
    },
    textFlexSpan:{
        paddingLeft:'20px'
    },
    arrowicon:{
        fontSize:'25px'
    },
    opennav:{
        display:'none',
        fontSize:'35px',
        padding:'7px 0 0 0',
        color:'#fff',
        
        [theme.breakpoints.down(1025)]: {
            display:'block', 
        }
    },    
    orange:{
        color:'#FF4630'
    },
    orangeBtn:{
        background:'#FF4630',
        color:'#fff',
        padding:'2px 10px',
        borderRadius:'50px',
        marginLeft:'5px',
        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            display:'none',            
        }
    },
    modalBox: {
        width: 500,
        height: 200,
        backgroundColor: '#fff',
        borderRadius: 10,
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalDiv:{
        display:'flex',
        alignItems: 'center',
        borderBottom:'1px solid #ccc'
    },




}));


const Header = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch()
    const { width } = useWindowDimensions();
    const login = useSelector(state => state.user.login);
    const mbLevel = useSelector(state => state.user.userInfo['mb_level']);
    const [isShown, setIsShown] = useState(true);
    const [toggleMenu, setToggleMenu] = useState(false)
    const [menus, setMenus] = useState([])
    const [keyword, setKeyword] = useState('')
    const [dialog, setDialog] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const theme = useTheme();
    let editTheme = {...theme, toggleMenu, isShown}
    const classes = useStyles(editTheme);
    const shopInfo = useSelector(state => state.config.shopDefaultConfig)


    const getMenus = useCallback(async() => {
        try {
            const res = await axios.get('/api/shop/getMenu/') 
    
            if (res.data.success === false) {
                setDialog('메뉴 불러오기 실패')
                return
            }
            setMenus(res.data.result);
    
        }catch (e) {
            console.log(e)
        }
    }, [])


    useEffect(() => {
        getMenus()
    }, [])

    useEffect(() => {
        if (width > 1025) {
            setToggleMenu(false)
        }
    }, [width])

    const goCateShop = useCallback((id) => {
        if(!login) return setDialog('로그인후 이용 가능 합니다.')
        navigate("/ShopMain/ShopList", {
            state: { caId: id }
        });
    }, [login])


    const onLogout = useCallback(() => {
        document.cookie = 'access_token' + '=; expires=Thu, 01 Jan 1999 00:00:10 GMT;';
        document.cookie = 'refresh_token' + '=; expires=Thu, 01 Jan 1999 00:00:10 GMT;';
        dispatch(setUserInfo({}))
        dispatch(setLogin(false))
        navigate("/");
    }, [])

    const onSearch = useCallback(() => {
        if(!login) return setDialog('로그인후 이용 가능 합니다.')
        if(keyword === '') return setDialog('검색어를 입력해주세요.')
        dispatch(setOrderAll('1'))
        dispatch(setPageAll(1))
        navigate("/ShopMain/ShopSearch", {
            state: { keyword: keyword }
        });
        setModalOpen(false)
        setKeyword('')
    }, [login, keyword])

    const handleOpen = () => {
        setModalOpen(true)
    }

    const handleClose = () => {
        setModalOpen(false)
    }


    return(
        <div className={classes.HeaderBlock}>
            <div>
                
                {isShown && (
                <div className={classes.banner} >
                    <span className={classes.bannerSpan}> 
                        &#60;꽃 사업주 전용 서비스&#62; 
                        <span className={classes.colorChange}>회원가입</span>
                        으로 특별한 서비스를 만나보세요!
                    </span>
                    <AiOutlineClose onClick={() => setIsShown(false) } className={classes.close}/> 
                </div>
                )}
                <div className={classes.row}>
                    <div className={classes.topmenu}>
                        <ul className={classes.topmenuUl}>    
                            <li className={classes.topmenuLi}><Link to="/CompanyInfo">회사소개</Link></li>
                            <li 
                                className={classes.topmenuLi}
                                onClick={() => {
                                    if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                    navigate("/BoardList", {
                                        state: { cateType: 'qanda' }
                                      });
                                }}
                            >
                                Q&#38;A
                            </li>
                            {login ? (
                                <>
                                <li className={classes.topmenuLi}><Link to="/CheckPass">회원정보 수정</Link></li>
                                <li 
                                    className={classes.topmenuLi}
                                    onClick={() => onLogout()}
                                >
                                    로그아웃
                                </li>
                                </>

                            ) : (
                                <>
                                <li className={classes.topmenuLi}><Link to="/Login">로그인</Link></li>
                                <li className={classes.topmenuLi}><Link to="/Register">회원가입</Link></li>
                                </>
                            )}
                            {
                                mbLevel === 10 && <li className={classes.topmenuLi}><Link to="/DashboardMain">관리자</Link></li>
                            }
                        </ul>
                    </div>
                </div>
                <div className={classes.logoFlexDiv}>
                    <div className={classes.leftDiv}>
                        <img className={classes.leftImg} src='/images/leftHeader.png' alt='문의하기' />
                        <div className={classes.leftNumber}>
                            {shopInfo['de_admin_company_tel']} / 
                            {shopInfo['de_sms_hp']}
                        </div>
                    </div>
                    <div className={classes.logoDiv}>
                            <Link to="/">
                                <img className={classes.pclogoimg} src='/images/logo.png' alt='로고' />
                            </Link>
                            <Link to="/">
                                <img 
                                    className={classes.mobilelogoimg} 
                                    style={{top: isShown ? '50%' : '30%'}}
                                    src='/images/Mlogo.png' 
                                    alt='로고' 
                                />
                            </Link>
                        <div 
                            className={classes.opennav} 
                            onClick={() => setToggleMenu(!toggleMenu)} 
                        >
                            <GiHamburgerMenu/>
                        </div>
                        <div className={classes.searchDiv}>
                            <div 
                                className={classes.responsiveSearchDiv}
                                style={{ top: isShown ? '45%' : '20%' }}
                            >
                                <input
                                    value={keyword}
                                    onChange={(e)=>setKeyword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            onSearch()
                                        }
                                    }}
                                    style={{
                                        flex: 1,
                                        outline: 'none',
                                        backgroundColor:'#007235', 
                                        border: 'none', 
                                        borderBottom: '1px solid #fff' ,
                                        color: '#fff'
                                    }}
                                />
                                <CgSearch 
                                    className={classes.responsiveSearch}
                                    onClick={onSearch}
                                />
                            </div>
                            <div 
                                className={classes.searchBtn}
                                style={{ top: isShown ? '38%' : '10%' }}
                            >
                                <Button
                                    style={{color:'#fff', fontFamily:['Noto Sans KR'], }}
                                    onClick={handleOpen} 
                                >
                                    검색
                                </Button>
                            </div>
                        </div>
                        
                    </div>
                    <div className={classes.rightDiv}>
                        <div className={classes.rightAbsoluteDiv}>
                            <div 
                                className={classes.rightDetailDiv}
                                onClick={() => {
                                    if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        navigate("/BoardList", {
                                        state: { cateType: 'notice' }
                                        });
                                    }}
                            >
                                <TbSpeakerphone className={classes.rightIcon}/>
                                <span className={classes.rightSpan}>
                                    공지사항
                                </span>
                            </div>
                            <div 
                                className={classes.rightDetailDiv}
                                onClick={() => {
                                    if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        navigate("/BoardList", {
                                        state: { cateType: 'after' }
                                        });
                                    }}
                            >
                                <TiPencil className={classes.rightIcon}/>
                                <span className={classes.rightSpan}>
                                    사용후기
                                </span>
                            </div>
                            <div 
                                className={classes.rightDetailDiv}
                                onClick={() => {
                                    if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        navigate("/BoardList", {
                                        state: { cateType: 'qanda' }
                                        });
                                    }}
                            >
                                <FaRegQuestionCircle className={classes.rightIcon}/>
                                <span className={classes.rightSpan}>
                                    상품문의
                                </span>
                            </div>
                            <div 
                                className={classes.rightDetailDiv}
                                onClick={() => {
                                    if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        navigate("/BoardList", {
                                        state: { cateType: 'fag' }
                                        });
                                    }}
                            >
                                <GoBook className={classes.rightIcon}/>
                                <span className={classes.rightSpan}>
                                    자주묻는질문
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <nav>
                    <div className={classes.row}>
                        <div className={classes.navDiv}>
                            <div className={classes.navUlFirst}>
                                {menus && menus.length > 0 && menus.map((item) => (
                                    <div 
                                        className={classes.navLi}
                                        key={item.me_id}
                                        onClick={() => {
                                            dispatch(setOrderAll('1'))
                                            dispatch(setPageAll(1))
                                            goCateShop(item.me_code)
                                        }}
                                    >
                                        {item.me_name}
                                    </div>
                                ))}
                                <div 
                                    className={classes.navLi}
                                    onClick={() => {
                                        if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        dispatch(setOrderAll('1'))
                                        dispatch(setPageAll(1))
                                        navigate('/ShopMain/ShopDiscount')
                                    }}
                                >
                                    특가상품
                                </div>
                                <div 
                                    className={classes.navLi}
                                    onClick={() => {
                                        if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                        navigate("/ItemRecommand");
                                    }}
                                >
                                    팀장추천꽃
                                </div>                                
                            </div> 
                            <ul className={classes.navUlSecond}>
                                <li>
                                    <div className={classes.searchForm}>
                                        <fieldset>
                                            <div className={classes.search}>
                                                <input 
                                                    className={classes.inputSearch} 
                                                    style={{
                                                        fontFamily:[
                                                            'Noto Sans KR'
                                                        ],
                                                    }}
                                                    placeholder="검색" 
                                                    value={keyword}
                                                    onChange={(e)=>setKeyword(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if(e.key === 'Enter') {
                                                            onSearch()
                                                        }
                                                    }}
                                                />
                                                <button 
                                                    className={classes.btnSearch}
                                                    onClick={onSearch}
                                                >
                                                    <img src='/images/ionic-ios-search.png' alt='돋보기' />
                                                </button>
                                            </div>
                                        </fieldset>
                                    </div>
                                </li>
                                <li className="navUlSecondIcon">
                                    <Link to="/MyPage">
                                        <BsPerson className={classes.io}/>
                                    </Link>
                                </li>
                                <li className="navUlSecondIcon">
                                    <Link to="/Cart">
                                        <FiShoppingCart className={classes.fi}/>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {(toggleMenu && (
                        <div className={classes.mobileBack}>
                            <div 
                                className={classes.toggleDiv} 
                                onClick={() => {setToggleMenu(false)}}
                            ></div>
                            <div 
                                className={classes.mobileNavDiv}
                                style={{top: isShown ? -137 : -88}}
                            >  
                                <ul className={classes.mobileGreenUl}>
                                    <li className={classes.mobileGreenLi}>
                                        {login ? (
                                            <div 
                                                className={classes.mobileLogin}
                                                onClick={() => onLogout()}
                                            >
                                                <span>로그아웃</span>
                                            </div>
                                        ) : (
                                            
                                            <div className={classes.mobileLogin} onClick={() => {setToggleMenu(false)}}>
                                                <Link to="/Login"><span className={classes.mobileLoginSpan1}>로그인</span> </Link>
                                                <Link to="/Register"><span className={classes.mobileLoginSpan1}><span className={classes.mobileLoginSpan2}>회원가입</span></span> </Link>
                                            </div>
                                        )}

                                        <div style={{marginRight: 15}} onClick={() => {setToggleMenu(false)}}>
                                            <MdOutlineClose/>
                                        </div>
                                    </li>
                                    {login && (
                                        <li className={classes.threeFlexLi}>
                                            <ul className={classes.threeFlex}>
                                                <Link to="/MyPage">
                                                <li className={classes.threeFlexIconLi} onClick={() => {setToggleMenu(false)}}>
                                                    <MdOutlinePersonOutline className={classes.threeFlexIcon}/>
                                                </li>
                                                <li className={classes.threeFlexTextLi}>마이페이지</li>
                                                </Link>
                                            </ul>
                                            <ul className={classes.threeFlex}>
                                                <Link to="/Cart">
                                                <li className={classes.threeFlexIconLi} onClick={() => {setToggleMenu(false)}}>
                                                    <RiShoppingCartLine className={classes.threeFlexIcon}/>
                                                </li>
                                                <li className={classes.threeFlexTextLi}>장바구니</li>
                                                </Link>
                                            </ul>
                                            <ul className={classes.threeFlex}>
                                                <Link to="/CheckPass">
                                                <li className={classes.threeFlexIconLi}  onClick={() => {setToggleMenu(false)}}>
                                                    <TbHeadphones className={classes.threeFlexIcon}/>
                                                </li>
                                                <li className={classes.threeFlexTextLi}>회원정보 수정</li>
                                                </Link>
                                            </ul>
                                        </li>
                                    )}
                                    
                                </ul>
                                <ul className={classes.mobileNavUlFirst}>
                                    <li className={classes.mobileNavUlFirstmenu}>꽃 카테고리</li>
                                    {menus && menus.length > 0 && menus.map((item) => (
                                        <li 
                                            className={classes.mobileNavLi}
                                            key={item.me_id}
                                            onClick={() => {
                                                dispatch(setOrderAll('1'))
                                                dispatch(setPageAll(1))
                                                goCateShop(item.me_code)
                                                setToggleMenu(false)
                                            }}
                                        >
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>{item.me_name}</span>
                                        </div>
                                            <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                        </li>
                                    ))}

                                    <li 
                                        className={classes.mobileNavLi}
                                        onClick={() => {
                                            if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                            dispatch(setOrderAll('1'))
                                            dispatch(setPageAll(1))
                                            setToggleMenu(false)
                                            navigate('/ShopMain/ShopDiscount')
                                        }}
                                    >
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>특가상품</span>
                                        </div>
                                        <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                    </li>
                                    <li 
                                        className={classes.mobileNavLi}
                                        onClick={() => {
                                            if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                            navigate("/ItemRecommand");
                                            setToggleMenu(false) 
                                        }}
                                    >
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>팀장 꽃 추천</span>
                                        </div>
                                        <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                    </li>
                                    <li className={classes.mobileNavUlFirstmenu2}>생초플라워</li>
                                    <li 
                                        className={classes.mobileNavLi}
                                        onClick={() => {
                                            if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                            navigate("/BoardList", {
                                                state: { cateType: 'notice' }
                                            });
                                            setToggleMenu(false)
                                        }}
                                    >
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>공지사항</span>
                                        </div>
                                        <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                    </li>
                                    <li 
                                        className={classes.mobileNavLi}
                                        onClick={() => {
                                            if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                            navigate("/BoardList", {
                                                state: { cateType: 'after' }
                                            });
                                            setToggleMenu(false)
                                        }}
                                    >
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>사용후기</span>
                                        </div>
                                        <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                    </li>
                                    <li 
                                        className={classes.mobileNavLi}
                                        onClick={() => {
                                            if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                            navigate("/BoardList", {
                                                state: { cateType: 'qanda' }
                                            });
                                            setToggleMenu(false)
                                        }}
                                    >
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>상품문의</span>
                                        </div>
                                        <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                    </li>
                                    <li 
                                        className={classes.mobileNavLi}
                                        onClick={() => {
                                            if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                            navigate("/BoardList", {
                                                state: { cateType: 'fag' }
                                            });
                                            setToggleMenu(false)
                                        }}
                                    >   
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>자주 묻는 질문</span>
                                        </div>
                                        <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                    </li>
                                    {
                                        mbLevel === 10 && (
                                        <li 
                                            className={classes.mobileNavLi}
                                            onClick={() => {
                                                if(!login) return setDialog('로그인후 이용 가능 합니다.')
                                                navigate('/DashboardMain')
                                                setToggleMenu(false)
                                            }}
                                        >
                                            
                                        <div className={classes.textFlex}>
                                            <div className={classes.colorBox}></div>
                                            <span className={classes.textFlexSpan}>관리자</span>
                                        </div>
                                            <MdKeyboardArrowRight  className={classes.arrowicon}/>
                                        </li>
                                        )
                                    }        
                  
                                </ul> 
                                {!login && (
                                        <div
                                            style={{width:'100%', height:'12vh', backgroundColor:'white'}}
                                        >

                                        </div>
                                )}    
                            </div>
                        </div>
                    ))}
                </nav>                
            </div>

            <div className={classes.modalDiv}>
                <Modal
                    open={modalOpen}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    className={classes.modal}
                    >
                    <Box
                        className={classes.modalBox}
                    >
                        <div 
                            className={classes.modalBoxDiv}
                            style={{
                                width: '100%', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center',
                                flexDirection: 'column'
                            }}
                        >
                            <div
                                style={{
                                    margin:'0 0 20px 0',
                                    fontFamily:[
                                        'Noto Sans KR'
                                    ],
                                }}
                            >
                                검색어를 입력해주세요.
                            </div>
                            <div
                                style={{
                                    width: '100%', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center',
                                }}
                            >
                                <input
                                    value={keyword}
                                    onChange={(e)=>setKeyword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            onSearch()
                                        }
                                    }}
                                    style={{
                                        width: '80%',
                                        height: 30,
                                        outline: 'none',
                                        border: 'none', 
                                        borderBottom: '1px solid #007235' ,
                                    }}
                                />
                                <CgSearch 
                                    style={{color:'#007235',}}
                                    onClick={() => {
                                        onSearch()
                                    }}
                                />
                            </div>
                        </div>
                        
                    </Box>
                </Modal>
            </div>

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                    {dialog}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setDialog('')} autoFocus>
                        확인
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )

}

export default Header;